module.exports = function (height, width) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var html = "\n    <style type=\"text/css\">\n      .hex {\n        width: ".concat(100 / width, "%\n      }\n      \n      .hex:nth-child(9n+6) {\n        margin-left: ").concat(100 / width / 2, "%\n      }\n    </style>\n  ");
  html += '<div id="game-hexgrid" class="game-hexgrid">';

  // rendering problem fix -- empty top row
  /*if ((height+1)%2 == 0) {
    for (let i = 0; i < width-1; i++) { html += '<li id="" class="hex"></li>'; }
  } else {
    for (let i = 0; i < width; i++) { html += '<li id="" class="hex"></li>'; }
  }*/

  var hexnum = 0;
  var width_adjustment = 0;
  for (var h = 1, hid = 1; h <= height; h++, hid++) {
    /*
      Mode has alternating arrays of length, width and width-1
      Widdy is the adjusted width (array length)
    */
    var widdy = h % 2 == 0 ? width - 1 : width;
    /*
     We want to shift the index once past the widest part of the hexagon to facilitate adjacency
    */
    if (h > (height + 1) / 2) {
      width_adjustment++;
    }
    for (var w = 1, wid = 1; w <= widdy; w++) {
      if (mode.length > 0) {
        if (mode[hexnum] == 1) {
          var id = hid + '_' + (wid + width_adjustment);
          html += "<div id=\"".concat(id, "\" class=\"hex\">\n\t                 <div class=\"hexIn\" id=\"hexIn_").concat(id, "\">\n                  <div class=\"hexLink\" id=\"hexLink_").concat(id, "\">\n            \t \t  <div class=\"hex_bg\" id=\"hex_bg_").concat(id, "\">\n            \t\t  </div></div></div>\n            \t    </div>");
          wid++;
        } else {
          html += "<div class=\"hex dummy\"></div>";
        }
        hexnum++;
      } else {
        var _id = hid + '_' + wid;
        html += "<div id=\"".concat(_id, "\" class=\"hex\">\n\t               <div class=\"hexIn\" id=\"hexIn_").concat(_id, "\">\n              \t <div class=\"hexLink\" id=\"hexLink_").concat(_id, "\">\n              \t <div class=\"hex_bg\" id=\"hex_bg_").concat(_id, "\">\n              \t </div></div></div>\n                 </div>");
        wid++;
      }
    }
  }

  // rendering problem fix -- empty bottom row
  /*if ((height+1)%2 == 0) {
    for (let i = 0; i < width-1; i++) { html += '<li id="" class="hex"></li>'; }
  } else {
    for (let i = 0; i < width; i++) { html += '<li id="" class="hex"></li>'; }
  }*/

  html += '</div>';
  return html;
};